import FaviconBadge from '@boshen/favicon-badge'
import { clone, setWith } from 'lodash'
import React from 'react'

import {
  GetNotifcationsDocument,
  useGetNotifcationsQuery,
  useNotificationCountChangedSubscription,
  useNotificationReadMutation,
} from '@/generated/graphql'

const faviconBadge = new FaviconBadge()

export const useNotificationUnreadQuery = () => {
  const variables = {
    isRead: false,
    pagination: {
      last: 0,
    },
  }

  const { data } = useGetNotifcationsQuery({
    variables,
  })

  const [readNotification] = useNotificationReadMutation({
    update(cache) {
      if (!data) {
        return
      }
      cache.writeQuery({
        query: GetNotifcationsDocument,
        id: cache.identify(data.viewer),
        variables,
        data: setWith(clone(data), ['viewer', 'notifications', 'totalCount'], 0, clone),
      })
    },
  })

  useNotificationCountChangedSubscription({
    onSubscriptionData({ client, subscriptionData }) {
      if (!data || !subscriptionData.data) {
        return
      }
      client.cache.writeQuery({
        query: GetNotifcationsDocument,
        variables,
        id: client.cache.identify(data.viewer),
        data: setWith(
          clone(data),
          ['viewer', 'notifications', 'totalCount'],
          subscriptionData.data.notificationCountChanged,
          clone
        ),
      })
    },
  })

  const unreadCount = data ? data.viewer.notifications.totalCount : 0

  React.useEffect(() => {
    if (unreadCount >= 1) {
      faviconBadge.draw(unreadCount > 100 ? '99+' : String(unreadCount))
    } else {
      faviconBadge.draw('')
    }
  }, [unreadCount])

  return {
    unreadCount,
    readNotification,
  }
}
